import { styled } from '@mui/material';
const Tooltip = styled('div')({
    borderRadius: "4px",
    boxShadow: "0px 0px 6px 0px #ccc",
    backgroundColor: "#fff",
    zIndex: 9,
    "& .arrow": {
        position: "absolute",
        width: "16px",
        height: "16px",
        background: "inherit",
        visibility: "hidden",
        transition: "top 0.3s ease-in, bottom 0.3s ease-in, left 0.3s ease-in, right 0.3s ease-in",
        "&::before": {
            position: "absolute",
            width: "16px",
            height: "16px",
            background: "inherit",
            visibility: "visible",
            content: "''",
            transform: "rotate(45deg)",
            transition: "top 0.3s ease-in, bottom 0.3s ease-in, left 0.3s ease-in, right 0.3s ease-in",
        }
    },
    "&[data-popper-placement^='bottom'] > .arrow": {
        top: "-8px",
        "&::before": {
            boxShadow: "-1px -1px 6px 0px #ccc"
        }
    },
    "&[data-popper-placement^='top'] > .arrow": {
        bottom: "-8px",
        "&::before": {
            boxShadow: "1px 1px 6px 0px #ccc"
        }
    },
    "&[data-popper-placement^='right'] > .arrow": {
        left: "-8px",
        "&::before": {
            boxShadow: "-1px 1px 6px 0px #ccc"
        }
    },
    "&[data-popper-placement^='left'] > .arrow": {
        right: "-8px",
        "&::before": {
            boxShadow: "1px -1px 6px 0px #ccc"
        }
    },
});
export default Tooltip;
